export const GRID_CELL_WIDTH = 320;

// GRID_CELL_HEIGHT = 1
// to match fx legacy behavior of tiles sticking to each others vertically
// this does not seem to create perf issue for the compactor, so far
export const GRID_CELL_HEIGHT = 1;

export const MIN_TILE_HEIGHT_IN_CELLS = Math.ceil(240 / GRID_CELL_HEIGHT);

export const MIN_TILE_HEIGHT = MIN_TILE_HEIGHT_IN_CELLS * GRID_CELL_HEIGHT;

export const TILE_OUTER_PADDING = 4; // px, padding between tile in the grid and internal tile content (including border and shadow)
